import Seo from "../components/Seo";
import { Reveal } from "../components/Reveal";
import { ProductCard } from "../components/ProductCard";
import { PRODUCTS } from "../data/products";

export default function Candles() {
  return (
    <div className="bg-ivory" data-testid="candles-page">
      <Seo
        title="Zelvoria Candles — Scented Luxury Candles"
        siteName="ZELVORIA"
        description="Hand-poured scented candles in Lavender, Vanilla, Sandalwood, Oud and more. The first collection from Zelvoria."
        image="/images/collection.jpg"
      />
      <header className="border-b border-beige/70 bg-parchment">
        <div className="mx-auto max-w-7xl px-6 py-20 text-center md:py-24">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.35em] text-gold">
              Scented Candles · The First Collection
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <h1 className="mt-4 font-serif text-5xl font-light text-ink md:text-6xl">Zelvoria Candles</h1>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mx-auto mt-5 max-w-lg text-sm font-light leading-relaxed text-taupe">
              Eight fragrances, hand-poured in small batches — each one a quiet ceremony for your space.
            </p>
          </Reveal>
        </div>
      </header>
      <div className="mx-auto max-w-7xl px-6 py-16 md:px-10 md:py-20">
        <div className="grid grid-cols-2 gap-x-5 gap-y-12 md:gap-x-8 lg:grid-cols-4" data-testid="product-grid">
          {PRODUCTS.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} />
          ))}
        </div>
      </div>
    </div>
  );
}
